export default function isValidPostalCode(postalCode, country) {
  if (country === 'ESP') {
    const postalCodeRegex = /^[0-9]{5}$/;
    return postalCodeRegex.test(postalCode);
  } else {
    return true;
  }
}
